import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryTabs() {
  const [active, setActive] = useState(categories[0].slug);

  const activeCat = categories.find((c) => c.slug === active) || categories[0];

  const getColorClasses = (color: string, isActive: boolean) => {
    if (!isActive) return '';
    const map: Record<string, string> = {
      accent: 'bg-accent-100/80 text-accent-800',
      primary: 'bg-primary-100/80 text-primary-800',
      secondary: 'bg-secondary-100/80 text-secondary-800',
    };
    return map[color] || 'bg-primary-100/80 text-primary-800';
  };

  const getIconColorClasses = (color: string, isActive: boolean) => {
    if (!isActive) return 'text-foreground-400';
    const map: Record<string, string> = {
      accent: 'text-accent-600',
      primary: 'text-primary-600',
      secondary: 'text-secondary-600',
    };
    return map[color] || 'text-primary-600';
  };

  const getActiveBarColor = (color: string) => {
    const map: Record<string, string> = {
      accent: 'bg-accent-500',
      primary: 'bg-primary-500',
      secondary: 'bg-secondary-500',
    };
    return map[color] || 'bg-primary-500';
  };

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            技术分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[500px] mx-auto">
            六大技术领域，覆盖编程开发、网络技术、AI数据等热门方向
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {categories.map((cat) => {
            const isActive = active === cat.slug;
            return (
              <button
                key={cat.slug}
                onClick={() => setActive(cat.slug)}
                className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  isActive
                    ? `${getColorClasses(cat.color, true)}`
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200/70'
                }`}
              >
                <span className={`w-4 h-4 flex items-center justify-center ${getIconColorClasses(cat.color, isActive)}`}>
                  <i className={`${cat.icon} text-sm`}></i>
                </span>
                {cat.name}
              </button>
            );
          })}
        </div>

        <div className="bg-background-100/70 rounded-xl p-6 md:p-8 border border-background-200/60">
          <div className="flex items-center gap-3 mb-6">
            <span className={`w-9 h-9 flex items-center justify-center rounded-lg ${getColorClasses(activeCat.color, true)}`}>
              <i className={`${activeCat.icon} ${getIconColorClasses(activeCat.color, true)}`}></i>
            </span>
            <div>
              <h3 className="text-lg font-heading font-bold text-foreground-950">{activeCat.name}</h3>
              <p className="text-sm text-foreground-500">{activeCat.description}</p>
            </div>
          </div>

          <div className={`h-0.5 w-16 rounded-full ${getActiveBarColor(activeCat.color)} mb-6`}></div>

          <div className="flex items-center justify-between">
            <p className="text-sm text-foreground-500">
              探索<strong className="text-foreground-800">{activeCat.name}</strong>分类下的所有文章
            </p>
            <Link
              to={`/category/${activeCat.slug}`}
              className="flex items-center gap-1.5 px-5 py-2 rounded-full text-sm font-medium text-white bg-primary-500 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              浏览全部
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}